import { render, staticRenderFns } from "./ticketflow.vue?vue&type=template&id=5973820a&"
import script from "./ticketflow.vue?vue&type=script&lang=js&"
export * from "./ticketflow.vue?vue&type=script&lang=js&"
import style0 from "./ticketflow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports